import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type IObject } from 'types';
interface AuthState {
  globalLoader: boolean;
  tenant: { id: number; tenantName: string; databaseName: string } | null;
  initialAPISuccess: boolean;
  tenantFetched: boolean;
  branchFetched: boolean;
  tableStatusFetched: boolean;
  branch: IObject | null;
}

const initialState: AuthState = {
  globalLoader: false,
  tenant: null,
  initialAPISuccess: false,
  tenantFetched: false,
  branchFetched: false,
  tableStatusFetched: false,
  branch: null,
};
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleTenantFetched(state, action: PayloadAction<boolean>) {
      state.tenantFetched = action.payload;
    },
    handleBranchFetched(state, action: PayloadAction<boolean>) {
      state.branchFetched = action.payload;
    },
    handleTableStatusFetched(state, action: PayloadAction<boolean>) {
      state.tableStatusFetched = action.payload;
    },
    handleInitialAPICallSuccess: (state, action: PayloadAction<boolean>) => {
      state.initialAPISuccess = action.payload;
    },
    handleGlobalLoader: (state, action) => {
      state.globalLoader = action.payload;
    },
    handleTenantData: (state, action) => {
      state.tenant = action.payload;
    },
    handleBranchData: (state, action) => {
      state.branch = action.payload;
    },
  },
});
export const {
  handleInitialAPICallSuccess,
  handleGlobalLoader,
  handleTenantData,
  handleBranchData,
  handleBranchFetched,
  handleTableStatusFetched,
  handleTenantFetched,
} = authSlice.actions;
export default authSlice.reducer;
export const selectCurrentUser = (state: any) => state.auth.user;
export const selectCurrentToken = (state: any) => {
  return state.auth.token;
};
